import request from '@/utils/ajax'// 军队合并todo


export function getLarkConfigList(params) {
    return request({
        url: '/wx/manage/larkAppConfig/list',
        method: 'get',
        params
    })
}

export function getLarkGroupChats(id, params) {
    return request({
        url: `/wx/manage/larkAppConfig/${id}/groupChats`,
        method: 'get',
        params
    })
}

export function getLarkPrivateChats(id, params) {
    return request({
        url: `/wx/manage/larkAppConfig/${id}/privateChats`,
        method: 'get',
        params
    })
}

export function getLarkGroupChatMembers(id, chatId, params) {
    return request({
        url: `/wx/manage/larkAppConfig/${id}/groupChats/${encodeURIComponent(chatId)}/members`,
        method: 'get',
        params
    })
}

export function saveLarkConfig(data) {
    return request({
        url: '/wx/manage/larkAppConfig/save',
        method: 'post',
        data: data
    })
}

export function editLarkConfig(data) {
    return request({
        url: '/wx/manage/larkAppConfig/update',
        method: 'put',
        data: data
    })
}

export function deleteLarkConfig(data) {
    return request({
        url: '/wx/manage/larkAppConfig/delete',
        method: 'post',
        data: data
    })
}
